// Observe mini cart for changes, call update function when it items are added/removed
var miniCart = document.querySelector('.js-mini-cart');
if (miniCart) {
	var cartItemsList = miniCart.querySelector('.c-cart__items-list');
	if (cartItemsList) {
		var miniCartObserver = new MutationObserver(function(mutations) {
			mutations.forEach(function(mutation) { 
				if (mutation.type === 'childList') {
					updateProductPricesForDE(miniCart);
				}
			});
		});
		miniCartObserver.observe(miniCart, { childList: true, subtree: false });
	}
}

// Get language
function getLanguage() {
	return (window.Shopify && Shopify.locale) || 'en';
}

// Format price for DE (move € to end). Only move if € is at the start, with or without whitespace
function formatEuroToEnd(priceText) {
  var match = priceText.match(/^\s*([+-]?)\s*€\s*([\d.,\s]+)$/u);
  if (match) {
    return (match[1] ? match[1] : '') + match[2].trim() + ' €';
  }
  return priceText;
}

// Main function to update prices for DE language
function updateProductPricesForDE(parentElement) {
	if (getLanguage().toLowerCase() !== 'de') return;
	parentElement.querySelectorAll('[data-price-cents], .js-product-price, .js-product-price-compare, .c-product-options__option-value--price, [data-cart-total], .js-search-product-price, .js-search-product-price-compare').forEach(function(el) {
		var original = el.textContent;
		var formatted = formatEuroToEnd(original);
		if (original !== formatted) el.textContent = formatted;
	});
}

// Run on DOM load
document.addEventListener('DOMContentLoaded', function() {
	updateProductPricesForDE(document);
});

// Quickshop modal handling. Observe when quickshop modal content is added/changed
document.querySelectorAll('.js-quickshop-trigger').forEach(function(el) {
  el.addEventListener('click', function() {
      let quickshopModal = document.querySelector('.js-quickshop-modal');
	  if (!quickshopModal) return;
      let quickShopModalContent = quickshopModal.querySelector('.js-quickshop-content');

		if (quickShopModalContent) {
			var quickshopObserver = new MutationObserver(function(mutations) {
				mutations.forEach(function(mutation) {
					if (mutation.type === 'childList' || mutation.type === 'characterData') {
						updateProductPricesForDE(quickShopModalContent);
					}
				});
			});
			quickshopObserver.observe(quickShopModalContent, { childList: true, characterData: true, subtree: true });
		}

  });
});

// Observe predictive search for when it opens (content is added), then update prices
var predictiveSearch = document.querySelector('.js-predictive-search');
if (predictiveSearch) {
    var predictiveSearchObserver = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
            if (
                mutation.type === 'attributes' &&
                mutation.attributeName === 'open' &&
                predictiveSearch.hasAttribute('open')
            ) {
                updateProductPricesForDE(predictiveSearch);
            }
        });
    });
    predictiveSearchObserver.observe(predictiveSearch, { attributes: true, attributeFilter: ['open'] });
}

// Observe changes to price elements to handle dynamic updates
var observer = new MutationObserver(function(mutations) {
	mutations.forEach(function(mutation) {
		if (mutation.type === 'childList' || mutation.type === 'characterData') {
			updateProductPricesForDE(document);
		}
	});
});

// Start observing all price elements
document.querySelectorAll('[data-price-cents], .js-product-price, .js-product-price-compare, .c-product-options__option-value--price, [data-cart-total], .js-search-product-price, .js-search-product-price-compare').forEach(function(el) {
	observer.observe(el, { childList: true, characterData: true, subtree: true });
});
